<label [for]="elementId" class="ot-field-label" [title]="hoverTip" *ngIf="label">
  <div *ngIf="isRequired" class="ot-required-indicator">*</div>{{label}}
</label>